// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__IPmtj","container":"footer_container__VR6Zb"};